"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UiEpic = void 0;
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _Core = _interopRequireDefault(require("../Core"));
var _types = require("../game/types");
var _types2 = require("../ui/types");
var _types3 = require("../loader/types");
var _types4 = require("../config/types");
var _RoundState = require("../enums/RoundState");
var _GameStatus = require("../enums/GameStatus");
var _types5 = require("../blitz/types");
var _types6 = require("../com/types");
var _actions = require("../sound/actions");
var _types7 = require("../sound/types");
var _types8 = require("../promotion/types");
var _types9 = require("../autoPlay/types");
var _DialogState = require("../../../ui/enums/DialogState");
var _coinsToCurrency = require("../../../utils/coinsToCurrency");
var _platformService = _interopRequireDefault(require("../../../utils/platformService"));
var _Channel = require("../../common/enums/Channel");
var _Orientation = require("../../common/enums/Orientation");
var _PromotionType = require("../../common/enums/PromotionType");
var _CommandType = require("../../dovahzul/CommandType");
var _ExitRequest = require("../../dovahzul/requests/ExitRequest");
var _PromotionStartRequest = require("../../dovahzul/requests/PromotionStartRequest");
var _SpinRequest = require("../../dovahzul/requests/SpinRequest");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UiEpic = exports.UiEpic = /*#__PURE__*/_createClass(function UiEpic() {
  var _this = this;
  _classCallCheck(this, UiEpic);
  _defineProperty(this, "_platformService", void 0);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.setDialogState, _this.setDialogStateActions, _this.toggleDialogState, _this.statusTextStateOnBlitz, _this.statusTextState, _this.statusTextSet, _this.spaceToSpin, _this.orientationBlock, _this.gameStatusPromptState, _this.onIdle, _this.blitzToggle, _this.gameExit, _this.dialogClose, _this.startTimer, _this.escToLeaveMenu, _this.blitzOfOnAutoPlay, _this.setRoundStartText, _this.setRoundEndText, _this.onHyperSpinStop, _this.onAutoPlayStopHide, _this.showAllPayLinesInGame, _this.uiButtonPress, _this.pendingServerResponse, _this.autoPlayButton, _this.customDialog);
  });
  _defineProperty(this, "startTimer", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.TIMER_START), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.timer)(0, 1000) // tick every 1000 ms
      .pipe((0, _operators.map)(function (i) {
        return a.payload - i;
      }), (0, _operators.take)(a.payload + 1), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types2.TIMER_CLEAR))), (0, _operators.mergeMap)(function (f) {
        var actions = [(0, _rxjs.of)({
          type: _types2.TIMER_TICK,
          payload: f
        })];
        if (f <= 9) {
          actions.push((0, _rxjs.of)((0, _actions.playSound)(_types7.SoundPack.Shared, false, "tick", 1 - f / 10)));
        } else {
          actions.push((0, _rxjs.of)((0, _actions.playSound)(_types7.SoundPack.Shared, false, "tick", 0.1)));
        }
        if (f == 0) {
          actions.push((0, _rxjs.of)((0, _actions.playSound)(_types7.SoundPack.Shared, false, "tickend", 1)));
        }
        return _rxjs.concat.apply(void 0, actions);
      }));
    }));
  });
  /**
   * Controls the prompt, ie error message. usually only use for un recoverable states where game will need restart.
   */
  _defineProperty(this, "gameStatusPromptState", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.GAME_STATUS_SET), (0, _operators.mergeMap)(function () {
      var state = store.value.game.gameStatus;
      switch (state) {
        case _GameStatus.GameStatus.InvalidToken:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.InvalidToken
          });
        case _GameStatus.GameStatus.PlayerLocked:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.PlayerLocked
          });
        case _GameStatus.GameStatus.ContactSupport:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.ContactSupport
          });
        case _GameStatus.GameStatus.InvalidPlayerId:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.InvalidPlayerId
          });
        case _GameStatus.GameStatus.Maintenance:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.Maintenance
          });
        case _GameStatus.GameStatus.APIDown:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.APIDown
          });
        case _GameStatus.GameStatus.Timeout:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.Timeout
          });
        case _GameStatus.GameStatus.Error:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.Error
          });
        case _GameStatus.GameStatus.FailedToConnect:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.FailedToConnect
          });
        case _GameStatus.GameStatus.GameInEarlyAccess:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.GameInEarlyAccess
          });
        case _GameStatus.GameStatus.CountryBlocked:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.CountryBlocked
          });
        case _GameStatus.GameStatus.ReplayRoundIdNotFound:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.ReplayRoundIdNotFound
          });
        case _GameStatus.GameStatus.Reconnecting:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.Reconnecting
          });
        case _GameStatus.GameStatus.Disconnected:
          {
            // if we are keeping alive, we should not display prompt. we should wait untill keep alive is done.
            if (!store.value.game.keepingAlive) return (0, _rxjs.of)({
              type: _types2.PROMPT_SET_STATE,
              payload: _types2.PromptState.Disconnected
            });else {
              // if the player now tryst to start a new round we set prompt, since we are in a state that cant be recovered from.
              return action$.pipe((0, _reduxObservable.ofType)(_types.ROUND_START), (0, _operators.mapTo)({
                type: _types2.PROMPT_SET_STATE,
                payload: _types2.PromptState.Disconnected
              }));
            }
          }
        case _GameStatus.GameStatus.Idle:
          return (0, _rxjs.of)({
            type: _types2.PROMPT_SET_STATE,
            payload: _types2.PromptState.Hide
          });
        default:
          return _rxjs.EMPTY;
      }
    }));
  });
  /**
   * CUstom engage dialog.
   * @param action$ 
   * @returns 
   */
  _defineProperty(this, "customDialog", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.REQUEST_CUSTOM_DIALOG), (0, _operators.mergeMap)(function (a) {
      var actions = [];
      /*
      {
        type: 'REQUEST_CUSTOM_DIALOG',
          payload: {
          header: 'herebeheader',
            content: 'herebecontent',
            actions: 'YESNO'
        }
      }
      */
      actions.push((0, _rxjs.of)({
        type: _types2.SET_DIALOG_CUSTOM_TEXT,
        payload: {
          header: a.payload.header,
          content: a.payload.content
        }
      }));
      actions.push((0, _rxjs.of)({
        type: _types2.SET_DIALOG_CUSTOM_ACTIONS,
        payload: a.payload.actions
      }));
      actions.push((0, _rxjs.of)({
        type: _types2.REQUEST_DIALOG_STATE_ACTIONS,
        payload: {
          state: 24,
          actions: {
            DIALOG_NO: [{
              type: _types.EXIT
            }],
            DIALOG_OK: []
          }
        }
      }));
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  _defineProperty(this, "setDialogStateActions", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.REQUEST_DIALOG_STATE_ACTIONS), (0, _operators.filter)(function (a) {
      return a.payload.state === _DialogState.DialogState.UNFINISHED_GAME ||
      // override states.
      store.value.game.roundState === _RoundState.RoundState.Ended && store.value.autoPlay.roundsLeft == 0 && !store.value.blitz.playing;
    }),
    // we prevent it to fire to quickly, like open then accidentally close.
    (0, _operators.throttle)(function (val) {
      return (0, _rxjs.interval)(200);
    }), (0, _operators.mergeMap)(function (a) {
      var actions = [];
      actions.push((0, _rxjs.of)({
        type: _types2.SET_DIALOG_ACTIONS,
        payload: a.payload.actions
      }));
      actions.push((0, _rxjs.of)({
        type: _types2.DIALOG_STATE,
        payload: a.payload.state
      }));
      actions.push((0, _rxjs.of)({
        type: _types9.AUTO_PLAY_STOP
      }));
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  _defineProperty(this, "setDialogState", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.REQUEST_DIALOG_STATE), (0, _operators.filter)(function (a) {
      return a.payload === _DialogState.DialogState.PROMOTION_END || a.payload === _DialogState.DialogState.RG_REMINDER ||
      // override any round state etc.
      store.value.game.roundState === _RoundState.RoundState.Ended && store.value.autoPlay.roundsLeft == 0 && !store.value.blitz.playing && store.value.ui.dialogState !== _DialogState.DialogState.BLITZ_FEATURE;
    } // DONT OPEN OTHER DIALOGS WHEN BLITZ DIALOG IS OPEN.
    ),
    // we prevent it to fire to quickly, like open then accidentally close.
    (0, _operators.throttle)(function (val) {
      return (0, _rxjs.interval)(200);
    }), (0, _operators.mergeMap)(function (a) {
      var actions = [];
      actions.push((0, _rxjs.of)({
        type: _types2.DIALOG_STATE,
        payload: a.payload
      }));
      actions.push((0, _rxjs.of)({
        type: _types9.AUTO_PLAY_STOP
      }));
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  _defineProperty(this, "toggleDialogState", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.TOGGLE_DIALOG_STATE), (0, _operators.throttle)(function () {
      return (0, _rxjs.interval)(300);
    }), (0, _operators.mergeMap)(function (a) {
      if (store.value.ui.dialogState === a.payload) {
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types2.REQUEST_DIALOG_STATE,
          payload: _DialogState.DialogState.CLOSED
        }));
      } else return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types2.REQUEST_DIALOG_STATE,
        payload: a.payload
      }));
    }));
  });
  _defineProperty(this, "showAllPayLinesInGame", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.SHOW_ALL_PAY_LINES), (0, _operators.filter)(function () {
      return !store.value.blitz.on;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.concat)((0, _rxjs.from)(_Core["default"].gameController.showAllPayLines()).pipe((0, _operators.mergeMap)(function () {
        return _rxjs.EMPTY;
      })), (0, _rxjs.of)({
        type: _types2.ESC_BUTTON
      }));
    }));
  });
  _defineProperty(this, "onAutoPlayStopHide", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types9.AUTO_PLAY_STOP), (0, _operators.filter)(function () {
      return !store.value.blitz.on;
    }), (0, _operators.mapTo)({
      type: _types2.SHOW_SPIN_BUTTON
    }));
  });
  _defineProperty(this, "spaceToSpin", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.SPACE_BUTTON), (0, _operators.filter)(function () {
      return store.value.config.spaceToSpinAllowed && store.value.config.spaceToSpin && store.value.ui.dialogState == _DialogState.DialogState.CLOSED;
    }), (0, _operators.mergeMap)(function () {
      // this to prevent spin on space when splash screen is shown.
      if (store.value.config.splashScreen) return (0, _rxjs.of)({
        type: _types4.HIDE_SPLASH_SCREEN
      });else return (0, _rxjs.of)({
        type: _types2.SPIN_BUTTON
      });
    }));
  });
  _defineProperty(this, "escToLeaveMenu", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.ESC_BUTTON), (0, _operators.filter)(function () {
      return store.value.ui.dialogState != _DialogState.DialogState.CLOSED;
    }), (0, _operators.mapTo)({
      type: _types2.REQUEST_DIALOG_STATE,
      payload: _DialogState.DialogState.CLOSED
    }));
  });
  /**
   * Allows us to trigger actions on close specific to what shown etc.
   */
  _defineProperty(this, "dialogClose", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.DIALOG_CANCEL, _types2.DIALOG_EXIT, _types2.DIALOG_OK, _types2.DIALOG_NO), (0, _operators.throttleTime)(500), (0, _operators.filter)(function () {
      return !store.value.ui.pendingServerResponse;
    }), (0, _operators.mergeMap)(function (a) {
      var actions = [];

      // Verify if there was any actions specified for this dialog to be send on close.
      // map them to the actual action/button player pressed.
      if (store.value.ui.dialogActions && store.value.ui.dialogActions[a.type]) {
        actions = [_rxjs.of.apply(void 0, _toConsumableArray(store.value.ui.dialogActions[a.type])), (0, _rxjs.of)({
          type: _types2.RESET_DIALOG_ACTIONS
        })];
      }

      // on feature continue, only supported with ft offers with more than 1 round, we just do a  spin and close dialog. We ONLY DO OK here.
      else if (store.value.ui.dialogState === _DialogState.DialogState.PROMOTION_NEXT) {
        switch (store.value.promotion.type) {
          case _PromotionType.PromotionType.FeatureTrigger:
            if (a.type == _types2.DIALOG_OK) {
              actions.push((0, _rxjs.of)({
                type: _types.ROUND_START
              }));
              actions.push((0, _rxjs.of)({
                type: _types6.COMMAND_SEND,
                payload: new _SpinRequest.SpinRequest(store.value.bet.coins, store.value.bet.lines, store.value.bet.denomination, {}, store.value.promotion.featureTriggerId, store.value.bet.featureSet)
              }));
              actions.push((0, _rxjs.of)({
                type: _types2.DIALOG_CLOSE
              }));
              return _rxjs.concat.apply(void 0, _toConsumableArray(actions));
            }
            break;
          default:
            {
              console.error("unhandled dialog state.");
            }
        }
      }
      // Note, we send this on all promotions, server will ignore if its not relevant.
      else if (store.value.ui.dialogState === _DialogState.DialogState.PROMOTION_START) {
        actions.push((0, _rxjs.of)({
          type: _types2.PENDING_SERVER_RESPONSE
        }));
        switch (store.value.promotion.type) {
          case _PromotionType.PromotionType.FreeGames:
            actions.push((0, _rxjs.of)({
              type: _types6.COMMAND_SEND,
              payload: new _PromotionStartRequest.PromotionStartRequest()
            }));
            break;
          case _PromotionType.PromotionType.Frenzy:
            actions.push((0, _rxjs.of)({
              type: _types6.COMMAND_SEND,
              payload: new _PromotionStartRequest.PromotionStartRequest()
            }));
            actions.push((0, _rxjs.of)({
              type: _types2.TIMER_START,
              payload: store.value.promotion.durationLeft / 1000
            }));
            break;
          case _PromotionType.PromotionType.FeatureTrigger:
            if (a.type == _types2.DIALOG_OK) {
              actions.push((0, _rxjs.of)({
                type: _types.ROUND_START
              }));
              actions.push((0, _rxjs.of)({
                type: _types6.COMMAND_SEND,
                payload: new _PromotionStartRequest.PromotionStartRequest()
              }));
              actions.push((0, _rxjs.of)({
                type: _types6.COMMAND_SEND,
                payload: new _SpinRequest.SpinRequest(store.value.bet.coins, store.value.bet.lines, store.value.bet.denomination, {}, store.value.promotion.featureTriggerId, store.value.bet.featureSet)
              }));
            }
            if (a.type == _types2.DIALOG_NO) {
              actions.push((0, _rxjs.of)({
                type: _types8.PROMOTION_CANCEL
              }));
            }
            break;
        }
        // We do NOT close the dialog, that will be done by the StartPromtotion response
        return _rxjs.concat.apply(void 0, _toConsumableArray(actions));
      } else if (store.value.ui.dialogState === _DialogState.DialogState.PROMOTION_END) {
        actions.push((0, _rxjs.of)({
          type: _types2.TIMER_CLEAR
        }));
        return _rxjs.concat.apply(void 0, _toConsumableArray(actions).concat([
        // prevent closing it to fast.
        (0, _rxjs.of)({
          type: _types2.REQUEST_DIALOG_STATE,
          payload: _DialogState.DialogState.CLOSED
        })]));
      } else if (store.value.ui.dialogState === _DialogState.DialogState.AUTOPLAY && a.type == _types2.DIALOG_OK) {
        actions.push((0, _rxjs.of)({
          type: _types9.AUTO_PLAY,
          payload: store.value.config.autoPlayRoundsToPlay
        }));
      }
      return _rxjs.concat.apply(void 0, _toConsumableArray(actions).concat([(0, _rxjs.of)({
        type: _types2.DIALOG_CLOSE
      })]));
    }));
  });
  _defineProperty(this, "pendingServerResponse", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types6.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.PromotionStartResponse === a.payload.type && store.value.ui.dialogState === _DialogState.DialogState.PROMOTION_START;
    }), (0, _operators.mapTo)({
      type: _types2.DIALOG_CLOSE
    }));
  });
  _defineProperty(this, "orientationBlock", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types4.WINDOW_RESIZE), (0, _operators.mergeMap)(function () {
      // try to go full screen when possible
      // we aggressivle go fullscreen for mobile devices that suppor the fullscreen api.
      if (store.value.config.fullscreen && store.value.config.channel == _Channel.Channel.Mobile && _this._platformService.checkFullScreenSupport()) {
        _this._platformService.createFullScreenTrap();
      }
      if (store.value.config.screenSize.orientation == _Orientation.Orientation.Landscape && !store.value.config.allowLandscape) return (0, _rxjs.of)({
        type: _types2.ORIENTATION_BLOCK,
        payload: _Orientation.Orientation.Landscape
      });else if (store.value.config.screenSize.orientation == _Orientation.Orientation.Portrait && !store.value.config.allowPortrait) return (0, _rxjs.of)({
        type: _types2.ORIENTATION_BLOCK,
        payload: _Orientation.Orientation.Portrait
      });else return (0, _rxjs.of)({
        type: _types2.ORIENTATION_BLOCK,
        payload: undefined
      });
    }));
  });
  _defineProperty(this, "onIdle", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.IDLE), (0, _operators.filter)(function () {
      return !!store.value.ui.idleText && !!store.value.ui.idleText.value && !store.value.blitz.on;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types2.STATUS_TEXT_SET,
        payload: store.value.ui.idleText
      });
    }));
  });
  /** Delay good luck text so that "hyper" spins counts. prevents GL to just take all space. */
  _defineProperty(this, "setRoundStartText", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.ROUND_START), (0, _operators.mergeMap)(function (a) {
      // good luck will only be set if
      if (store.value.ui.statusTextState == _types2.StatusTextState.Idle || store.value.autoPlay.on) {
        return (0, _rxjs.of)({
          type: _types2.STATUS_TEXT_GL
        });
      }
      return (0, _rxjs.of)({
        type: _types2.STATUS_TEXT_GL
      }).pipe((0, _operators.delay)(200), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types.ROUND_END, _types.PAYLINE_WIN, _types.QUICK_STOP))));
    }));
  });
  /**  work with hyper spin bashing. delays Idle message */
  _defineProperty(this, "setRoundEndText", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.ROUND_END), (0, _operators.filter)(function (a) {
      return !a.payload.totalCoinsWon && !store.value.autoPlay.on;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.of)({
        type: _types2.STATUS_TEXT_STATE,
        payload: _types2.StatusTextState.Idle
      }).pipe((0, _operators.delay)(200), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types.ROUND_START))));
    }));
  });
  /**
   * Reset/handle status text when going into blitz.
   */
  _defineProperty(this, "statusTextStateOnBlitz", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types5.BLITZ_MODE_ON, _types5.BLITZ_PLAY_STOP, _types5.BLITZ_PLAY_START), (0, _operators.mergeMap)(function (a) {
      switch (a.type) {
        case _types5.BLITZ_PLAY_STOP:
        case _types5.BLITZ_MODE_ON:
          return (0, _rxjs.of)({
            type: _types2.STATUS_TEXT_STATE,
            payload: _types2.StatusTextState.Blitz
          });
        case _types5.BLITZ_PLAY_START:
          return (0, _rxjs.of)({
            type: _types2.STATUS_TEXT_STATE,
            payload: _types2.StatusTextState.BlitzStop
          });
      }
    }));
  });
  /**
   * Shared status text handling.
   */
  _defineProperty(this, "statusTextState", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.LOADING_COMPLETED, _types2.STATUS_TEXT_GL, _types.PAYLINE_WIN, _types.IDLE, _types.GAME_FEATURE_START, _types.GAME_WINCOUNTER_SET), (0, _operators.filter)(function () {
      return !store.value.blitz.on;
    }), (0, _operators.mergeMap)(function (a) {
      var state;
      switch (a.type) {
        case _types.IDLE:
        case _types3.LOADING_COMPLETED:
          state = _types2.StatusTextState.Idle;
          break;
        case _types2.STATUS_TEXT_GL:
          // hack for reconnect, will ensure that the win counter does not get overridden by the GL from Round start.
          if (store.value.game.reconnect) return _rxjs.EMPTY;
          state = _types2.StatusTextState.Running;
          break;
        case _types.PAYLINE_WIN:
        case _types.GAME_WINCOUNTER_SET:
        case _types.GAME_FEATURE_START:
          {
            // happens in reconnects on swipe's, temp fix
            // added the is mobile check since this breaks desktop game info bar on older games (info bar 3 using dedicated state is not)
            // related to below fix., idle check is for reconnect/resume features not to remove press spin to start.
            if (store.value.config.mobileGameInfo && store.value.config.channel == _Channel.Channel.Mobile && store.value.ui.statusTextState != _types2.StatusTextState.Idle) {
              return (0, _rxjs.concat)(
              //  of({ type: STATUS_TEXT_STATE, payload: StatusTextState.Win }),
              (0, _rxjs.of)({
                type: _types2.STATUS_TEXT_SET,
                payload: {
                  value: ''
                }
              }));
            } else if (store.value.game.winCounter) {
              return (0, _rxjs.concat)(
              // This added 2023-12-04, if we dont actually set the state to win, the GL wont show (on none hyper spins) since the state will be same as before not triggering the sub.
              // issue for many older games. Only fixes for desktop.
              (0, _rxjs.of)({
                type: _types2.STATUS_TEXT_STATE,
                payload: _types2.StatusTextState.Win
              }), (0, _rxjs.of)({
                type: _types2.STATUS_TEXT_SET,
                payload: {
                  value: _Core["default"].translate("statusText" + _types2.StatusTextState.Win) + (0, _coinsToCurrency.coinsToCurrency)(store.value.game.winCounter)
                }
              }));
            } else {
              return _rxjs.EMPTY;
            }
          }
      }
      return (0, _rxjs.of)({
        type: _types2.STATUS_TEXT_STATE,
        payload: state
      });
    }));
  });
  /** Set the status text based on state, triggers translation. */
  _defineProperty(this, "statusTextSet", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.STATUS_TEXT_STATE), (0, _operators.mergeMap)(function (a) {
      var state = a.payload;
      var text;
      switch (state) {
        case _types2.StatusTextState.TotalWin:
          if (store.value.config.mobileGameInfo) {
            text = '';
            break;
          }
          text = _Core["default"].translate("statusText" + state) + " " + store.value.game.totalWinFormatted;
          break;
        case _types2.StatusTextState.Idle:
          text = _Core["default"].translate("statusText0").replace("{0}", '<span class="play_classic info_symbol blink_slow"></span>');
          break;
        case _types2.StatusTextState.Blitz:
          text = _Core["default"].translate("statusText6").replace("{0}", '<span class="play_blitz info_symbol blink_slow"></span>');
          break;
        case _types2.StatusTextState.BlitzStop:
          text = _Core["default"].translate("statusText7").replace("{0}", '<span class="play_blitz_stop info_symbol blink_slow"></span>');
          break;
        default:
          {
            if (state == _types2.StatusTextState.Running && store.value.config.mobileUiNoGL) {
              text = '';
              break;
            }
            text = _Core["default"].translate("statusText" + state);
            break;
          }
      }
      return (0, _rxjs.of)({
        type: _types2.STATUS_TEXT_SET,
        payload: {
          value: text
        }
      });
    }));
  });
  _defineProperty(this, "blitzToggle", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.BLITZ_TOGGLE_BUTTON), (0, _operators.filter)(function () {
      return store.value.game.roundState != _RoundState.RoundState.Started && !store.value.autoPlay.on && store.value.ui.dialogState == _DialogState.DialogState.CLOSED && !store.value.blitz.starting;
    }), (0, _operators.mergeMap)(function () {
      // stop blitz if running then return, softer user experience.
      // this protects about slow devices/network when you blitz a bonus round, and exists blitz.
      // TODO UI REPRESENTATION OF THIS.
      if (store.value.blitz.roundState == _RoundState.RoundState.Started) console.warn("Blitz round on going, wait for it to end.");
      if (store.value.blitz.playing || store.value.blitz.roundState == _RoundState.RoundState.Started) return (0, _rxjs.of)({
        type: _types5.BLITZ_PLAY_STOP
      });
      if (!store.value.blitz.on && store.value.config.blitzAllowed && store.value.promotion.type != _PromotionType.PromotionType.Frenzy) return (0, _rxjs.of)({
        type: _types5.BLITZ_MODE_ON
      });else return (0, _rxjs.of)({
        type: _types5.BLITZ_MODE_OFF
      });
    }));
  });
  _defineProperty(this, "blitzOfOnAutoPlay", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types9.AUTO_PLAY), (0, _operators.filter)(function () {
      return store.value.blitz.on;
    }), (0, _operators.mapTo)({
      type: _types5.BLITZ_MODE_OFF
    }));
  });
  /**
   * This allows the core to manually tell the UI to stop any Hyper spins.
   * there is an issue with touch events just disspareas between features cuasing it to continue after the button has been released.
   *
   */
  _defineProperty(this, "onHyperSpinStop", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.HYPER_SPIN_STOP),
    //filter(() => store.value.blitz.on),
    (0, _operators.mergeMap)(function () {
      /// for some reason, between freespins touch event gets abondened, by firing this we
      //  window.dispatchEvent(new Event('touchmove'));
      window.dispatchEvent(new Event("touchcancel"));
      return _rxjs.EMPTY;
    }));
  });
  _defineProperty(this, "gameExit", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.EXIT, _types.EXIT_TO), (0, _operators.filter)(function () {
      return store.value.game.roundState != _RoundState.RoundState.Started && !store.value.blitz.playing && !store.value.game.exited && store.value.ui.dialogState != _DialogState.DialogState.BLITZ_FEATURE || store.value.game.sessionExpired;
    }), (0, _operators.mergeMap)(function (a) {
      var exitUrl;
      switch (a.payload) {
        case _types.ExitReason.RealityCheck:
          exitUrl = store.value.config.rcExitUrl;
        case _types.ExitReason.RealityCheckHistory:
          exitUrl = store.value.config.rcAccountHistoryUrl;
        case _types.ExitReason.PlayForReal:
          exitUrl = store.value.config.pfrUrl;
      }

      // if reason did not set one, go with standard.
      if (!exitUrl) exitUrl = store.value.config.exitUrl;
      if (exitUrl) {
        window.location.href = exitUrl;
      } else {
        window.history.back();
      }
      if (a.type == _types.EXIT_TO) window.location.href = a.payload;
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types.EXITING
      }), (0, _rxjs.of)({
        type: _types6.COMMAND_SEND,
        payload: new _ExitRequest.ExitRequest()
      }));
    }));
  });
  /**
   * Send ui press to game, for now only spin, add that should be.
   * @param action$
   * @param store
   */
  _defineProperty(this, "uiButtonPress", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.SPIN_BUTTON),
    // ensure game is ready.
    (0, _operators.filter)(function () {
      return store.value.game.gameReady;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.uiButtonPress(a.type)).pipe((0, _operators.mergeMap)(function () {
        return _rxjs.EMPTY;
      }));
    }));
  });
  /**
   * AutoPlayButton press.
   * @param action$
   * @param store
   */
  _defineProperty(this, "autoPlayButton", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.AUTO_PLAY_BUTTON), (0, _operators.mergeMap)(function (a) {
      if (store.value.game.roundState == _RoundState.RoundState.Ended && store.value.config.autoPlayAllowed && !store.value.game.locked && store.value.ui.dialogState == _DialogState.DialogState.CLOSED) {
        return (0, _rxjs.of)({
          type: _types2.REQUEST_DIALOG_STATE,
          payload: _DialogState.DialogState.AUTOPLAY
        });
      } else if (store.value.game.featureFreeSpins && store.value.config.manualFreeSpins && store.value.config.autoPlayAllowed) {
        return (0, _rxjs.of)({
          type: _types9.AUTO_PLAY_FREE_SPIN_START
        });
      } else return _rxjs.EMPTY;
    }));
  });
  this._platformService = _platformService["default"];
});
//# sourceMappingURL=epics.js.map